<template>
  <div class="cxrwrapper">
    <mescroll-vue
      ref="mescroll"
      :down="down"
    >
      <div
        v-show="checkedList.length > 0"
        class="checkedNameList van-hairline--bottom"
      >
        <span
          v-for="(info, index5) in checkedList"
          :key="index5"
          class="inline-block pad-b-6"
        >
          <span
            v-if="(info.psgType && info.psgType == 1) || (info.passengerType && info.passengerType == 1) || (!info.psgType && !info.passengerType) || (info.psgType && info.psgType == 2)"
            class="tagName"
            @click.stop="$emit('dele', info, index5)"
          >{{ info | getName }}</span>
          &nbsp;
        </span>
      </div>
      <van-list
        v-model="page.loading"
        :error-text="page.errorText"
        :error.sync="page.error"
        :finished="page.finished"
        :finished-text="page.finishedText"
        :immediate-check="false"
        :offset="0"
        class="pad van-clearfix"
        @load="load"
      >
        <van-row>
          <van-col span="1" />
          <van-col span="23">
            <van-checkbox
              v-for="(info,index4) in empList"
              :key="index4"
              v-model="info.checked"
              class="empList van-hairline--bottom"
              @change="check(info)"
            >
              <div class="empList-item ">
                <div class="empList-name">
                  <span v-show="index==0||index==2"> {{ info | getName }}</span>
                  <span v-show="index==1">{{ info | getName }}</span>&nbsp;
                  <van-tag
                    v-show="info.isCivil==1"
                    plain
                    type="danger"
                  >
                    {{ info.isCivil == 1 ? '公务员' : '' }}
                  </van-tag>
                </div>
                <div v-show="index==0||index==2">
                  {{ $t('F008', '手机号') }}：{{ info.phoneNumber }}
                </div>
                <div v-show="index==1">
                  {{ $t('D011', '工号') }}：{{ info.empNo }}&nbsp;
                  {{ $t('D012', '部门') }}：{{ info.deptName }}
                </div>
              </div>
            </van-checkbox>
          </van-col>
        </van-row>
      </van-list>
    </mescroll-vue>
  </div>
</template>
<script>
import {Cell, Checkbox, Dialog, List, Tag, Toast} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'EmpList',
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    MescrollVue,
  },
  data() {
    return {
      NI: '',
      down: {use: false},
      empList: []
    }
  },
  props: {
    page: {
      type: Object,
      default: function () {
        return {}
      }
    },
    lists: {//要展示出行人列表
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    checkedList: {//选中出行人列表
      type: Array,
      default: function () {
        return []
      }
    },
    index: {
      type: [String, Number],
      default: '1'
    },
  },
  methods: {
    load() {
      this.page.pageNum += 1
      this.$emit('get-list')
    },
    check(info) {
      if (info.checked == true) {
        if (this.$route.query.i == 2) {
          if (info.cardNo == '') {
            setTimeout(() => {
              Toast('身份证不能为空')
              info.checked = false
            }, 350)}
          // } else {
          // 	var file = JSON.parse(sessionStorage.getItem('flights'))
          // 	var cache = JSON.parse(sessionStorage.getItem('cache'))
          // 	const birthday = info.idNumber.substr(6, 8) // 提取出生日期，例如：19900101
          // 	const year = birthday.substr(0, 4) // 提取出生年份，例如：1990
          // 	const month = birthday.substr(4, 2) - 1 // 提取出生月份，需要减去 1，因为月份从 0 开始计数
          // 	const day = birthday.substr(6, 2) // 提取出生日，例如：01
          // 	const birthDate = new Date(year, month, day) // 将出生日期转换为日期对象
          // 	const now = new Date() // 获取当前日期对象
          // 	const age = now.getFullYear() - birthDate.getFullYear() // 计算年龄
          // 	console.log(file)
          // 	var _obj = [
          // 		{
          // 			'cacheId': cache[0].cacheId,
          // 			'priceId': cache[0].priceId,
          // 			'flightNo': cache[0].flightNo,
          // 			'cardNo': info.idNumber,
          // 			'cardType': 'NI',
          // 			'age': age
          // 		}
          // 	]
          // 	this.$api['tkQuery/checkXyhAge']({
          // 		datas: _obj
          // 	}).then(res => {
          // 		if (res.data.checkResult == false) {
          // 			setTimeout(() => {
          // 				Dialog({message: res.data.resultMsg})
          // 				info.checked = false
          // 			}, 350)
          // 			info.checked = false
          // 		} else {
          // 			if (res.data.resultMsg == 'SUCCESS') {

          // 			} else {
          // 				Dialog.confirm({
          // 					title: '温馨提示!',
          // 					message: res.data.resultMsg,
          // 					confirmButtonText: '继续',
          // 					cancelButtonText: '返回',
          // 				})
          // 					.then(() => {
          // 						// this.$router.go(-1)
          // 					})
          // 					.catch(() => {
          // 						// on cancel
          // 						this.$router.push('/tk/tkList?routeId=')
          // 					})
          // 			}

          // 		}
          // 	})

          // }
        }
      }

      this.$emit('check', info)
    }
  },
  watch: {
    lists() {
      this.empList = this.lists
    }
  }
}
</script>
<style lang="less" scoped>
.pad {
  padding: 5px 8px;
}

.cxrwrapper {
  height: calc(100vh - 148px);
  overflow: hidden;
}

.pad-b-6 {
  padding-bottom: 6px;
}

// 上中人名列表
.checkedNameList {
  padding: 6px;
  background-color: @color-background-white;
}

.empList {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  .empList-item {
    font-size: @font-size-12;
    color: @color-text-gray;
    padding: 18px 0px;

    .empList-name {
      font-size: @font-size-16;
      color: @color-text-black;
    }
  }
}

.tagName {
  position: relative;
  display: inline-block;
  height: 36px;
  line-height: 36px;
  font-size: @font-size-12;
  padding: 0 20px;
  color: @color-text-red;
  border: 1px solid @color-text-red;
  background-color: #fff7f6;
  border-radius: 4px;
}

.tagName::before {
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  content: '-';
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  line-height: 12px;
  text-align: center;
  color: @color-text-white;
  background-color: @color-text-red;
  font-size: @font-size-26;
  border-bottom-left-radius: 4px;
}
</style>
